var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapViewDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15418_38518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 4.81925C1.83325 3.1702 3.26967 1.83337 5.04159 1.83337C6.8135 1.83337 8.24992 3.1702 8.24992 4.81925C8.24992 6.45538 7.22593 8.36459 5.62828 9.04734C5.25584 9.2065 4.82733 9.2065 4.45489 9.04734C2.85724 8.36459 1.83325 6.45538 1.83325 4.81925Z",
    stroke: "#1C274C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 15.8192C13.75 14.1702 15.1864 12.8334 16.9583 12.8334C18.7302 12.8334 20.1667 14.1702 20.1667 15.8192C20.1667 17.4554 19.1427 19.3646 17.545 20.0473C17.1726 20.2065 16.7441 20.2065 16.3716 20.0473C14.774 19.3646 13.75 17.4554 13.75 15.8192Z",
    stroke: "#1C274C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8751 16.0417C17.8751 16.5479 17.4647 16.9583 16.9584 16.9583C16.4522 16.9583 16.0417 16.5479 16.0417 16.0417C16.0417 15.5354 16.4522 15.125 16.9584 15.125C17.4647 15.125 17.8751 15.5354 17.8751 16.0417Z",
    fill: "#1C274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 5.04167C5.95833 5.54793 5.54793 5.95833 5.04167 5.95833C4.53541 5.95833 4.125 5.54793 4.125 5.04167C4.125 4.53541 4.53541 4.125 5.04167 4.125C5.54793 4.125 5.95833 4.53541 5.95833 5.04167Z",
    fill: "#1C274C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 3.58337C10.4476 3.58337 9.99991 4.03109 9.99991 4.58337C9.99991 5.13566 10.4476 5.58337 10.9999 5.58337V3.58337ZM10.9999 17.4167L11.707 18.1238C12.0975 17.7333 12.0975 17.1001 11.707 16.7096L10.9999 17.4167ZM15.7717 7.96342L16.3086 8.80708L15.7717 7.96342ZM6.22809 14.0367L6.76496 14.8803H6.76496L6.22809 14.0367ZM10.332 15.3346C9.9415 14.9441 9.30833 14.9441 8.91781 15.3346C8.52728 15.7251 8.52728 16.3583 8.91781 16.7488L10.332 15.3346ZM8.91781 18.0846C8.52728 18.4751 8.52728 19.1083 8.91781 19.4988C9.30833 19.8893 9.9415 19.8893 10.332 19.4988L8.91781 18.0846ZM14.7875 3.58337H10.9999V5.58337H14.7875V3.58337ZM10.9999 16.4167H7.21235V18.4167H10.9999V16.4167ZM15.2349 7.11976L5.69121 13.193L6.76496 14.8803L16.3086 8.80708L15.2349 7.11976ZM11.707 16.7096L10.332 15.3346L8.91781 16.7488L10.2928 18.1238L11.707 16.7096ZM10.2928 16.7096L8.91781 18.0846L10.332 19.4988L11.707 18.1238L10.2928 16.7096ZM7.21235 16.4167C6.37866 16.4167 6.06159 15.3279 6.76496 14.8803L5.69121 13.193C3.29978 14.7148 4.37774 18.4167 7.21235 18.4167V16.4167ZM14.7875 5.58337C15.6212 5.58337 15.9382 6.67216 15.2349 7.11976L16.3086 8.80708C18.7001 7.28525 17.6221 3.58337 14.7875 3.58337V5.58337Z",
    fill: "#1C274C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15418_38518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapViewDark);
export default __webpack_public_path__ + "static/media/map-view-dark.23b955389e7d769696a7e13f6a782c62.svg";
export { ForwardRef as ReactComponent };